import { AgDialog } from '@australiangreens/ag-internal-components';
import { Typography } from '@mui/material';

type EditCriteriaWarningModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onProceed: () => void;
  onRestart?: () => void;
  showRestartButton?: boolean;
};

export default function EditCriteriaWarningModal({
  isOpen,
  onCancel,
  onProceed,
  onRestart,
  showRestartButton = false,
}: EditCriteriaWarningModalProps) {
  const additionalButtons =
    showRestartButton && onRestart
      ? [
          {
            text: 'Restart',
            onClick: async () => onRestart(),
            testId: 'edit-criteria-restart-button',
          },
        ]
      : undefined;

  return (
    <AgDialog
      dialogTitle="Edit criteria"
      isOpen={isOpen}
      onClose={onCancel}
      primaryButton={{
        text: 'Proceed',
        onClick: async () => onProceed(),
        testId: 'edit-criteria-proceed-button',
      }}
      secondaryButton={{
        text: 'Cancel',
        onClick: async () => onCancel(),
        testId: 'edit-criteria-cancel-button',
      }}
      additionalButtons={additionalButtons}
      data-testid="edit-criteria-warning-modal"
    >
      <Typography variant="body1" gutterBottom>
        Your search criteria will be different from the search template that you have loaded. Are
        you sure you want to proceed?
      </Typography>
      <Typography variant="body1" component="p">
        <em>
          Note: click RESTART instead if you would like to change the selections you made for the
          search template
        </em>
      </Typography>
    </AgDialog>
  );
}
